import { z } from 'zod/v4';
import type { CreateOrderEventPayload } from '../../core/use-cases/types.js';

export const CreateTracingFromOrderLineInputSchema = z.object({
  orderLineIds: z.array(z.string().min(1)).min(1).max(1),
  attachmentTemplateId: z.string().min(1),
  attachments: z
    .array(
      z.object({
        fileId: z.string().min(1).optional().nullable(),
        type: z.string(),
        name: z.string().optional(),
        reference: z.string().optional(),
        description: z.string().optional(),
        documentId: z.string().min(1).optional().nullable(),
      }),
    )
    .optional(),
  orderTags: z.array(z.string().min(1)).optional().nullable(),
  orderTypeId: z.string().min(1).optional().nullable(),
});

export type CreateTracingFromOrderLineInput = z.infer<
  typeof CreateTracingFromOrderLineInputSchema
>;

export type CreateTracingPurchaseOrderFromOrderLineResult = {
  purchaseOrderId: string;
  tracingOrderId: string;
  eventPayload: CreateOrderEventPayload;
};

export type CreateTracingSalesOrderFromOrderLineResult = {
  salesOrderId: string;
  tracingOrderId: string;
  eventPayload: CreateOrderEventPayload;
};
